import FileManager from "components/file-manager/file-manager";

export default function InvestorUpdates() {
    return (
        <>
        <div className="investor-updates">
            <FileManager includeCaseName />
        </div>
        </>
    )
}